import axiosClient from './axiosClient';

export const getAuthHeader = (cache = true) => {
  return {
    Authorization: `Bearer ${process.env.NEXT_PUBLIC_STUDENT_API_TOKEN}`,
    'Cache-Control': cache ? (process.env.NEXT_PUBLIC_CACHE_CONTROL ?? '') : 'no-cache',
  };
};

const apiService = {
  get: async (url: string, params?: any, cache?: boolean): Promise<any> => {
    try {
      const response = await axiosClient.get(url, {
        params,
        headers: getAuthHeader(cache),
      });
      return response.data;
    } catch (error) {
      console.error('GET request error:', error);
      throw error;
    }
  },

  post: async (url: string, data: any): Promise<any> => {
    try {
      const response = await axiosClient.post(url, data, {
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      console.error('POST request error:', error);
      throw error;
    }
  },

  put: async (url: string, data: any): Promise<any> => {
    try {
      const response = await axiosClient.put(url, data, {
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      console.error('PUT request error:', error);
      throw error;
    }
  },

  delete: async (url: string): Promise<any> => {
    try {
      const response = await axiosClient.delete(url, {
        headers: getAuthHeader(),
      });
      return response.data;
    } catch (error) {
      console.error('DELETE request error:', error);
      throw error;
    }
  },
};

export default apiService;
